import MainLayout from 'src/layouts';
import { Helmet } from 'react-helmet';
import OrderConfirmation from 'src/features/OrderConfirmation';

const OrderConfirmationPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Order Confirmation</title>
      </Helmet>
      <OrderConfirmation />
    </MainLayout>
  );
};

export default OrderConfirmationPage;
